const { useTheme } = require('@mui/material/styles');

export const useDatePickerStyles = () => {
    const theme = useTheme();

const styles = {
    scrollbar: {
      '&::-webkit-scrollbar': {
        width: '8px',
        height: '8px',
      },
      '&::-webkit-scrollbar-thumb': {
        borderRadius: '8px',
        backgroundColor: theme.palette.primary.light,
        '&:hover': {
          backgroundColor: theme.palette.primary.main,
        },
      },
      '&::-webkit-scrollbar-track': {
        borderRadius: '8px',
        backgroundColor: '#f2f2f2',
      },
    },
  };
  
  const dayButtonClass = {
    height: '64px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginRight: '10px', 
    border: "none",
    '&:hover': {
      border: "none"
    },
    '&:last-child': {
      marginRight: 0, 
    },
    '& .day': {
      fontStyle: 'normal',
      fontWeight: '400',
      fontSize: '14px',
      lineHeight: '18px',
      color: theme.palette.text.secondary, 
    },
    '& .date': {
      display: 'flex',
      fontStyle: 'normal',
      fontWeight: '400',
      fontSize: '15px',
      lineHeight: '20px',
      justifyContent:' center',
      alignItems: 'center',
      height: '32px',
      width: '32px',
      color: theme.palette.text.primary, 
    },
    '& .pressed': {
      color: theme.palette.common.white, 
      backgroundColor: theme.palette.primary.main, 
      borderRadius: '50%',
    },
  };
  return { styles, dayButtonClass };
}